<template>
  <div
    v-if="!consentGiven"
    class="fixed bottom-0 inset-x-0 bg-black/90 text-white p-4 flex flex-col items-start gap-2 z-50"
  >
    <p class="text-sm mb-2 sm:mb-0">
      We use cookies to improve your experience. Read our
      <a href="/privacy-policy" class="underline text-purple-600">Privacy Policy</a>
      .
    </p>
    <div class="gap-2">
      <button
        class="text-sm bg-purple-600 hover:bg-purple-700 text-white px-2 py-1 rounded"
        @click="acceptConsent"
      >
        Accept
      </button>
    </div>
  </div>
</template>
  
  <script>
export default {
  name: 'CookieConsent',
  data() {
    return {
      consentGiven: false,
    }
  },
  mounted() {
    const consent = localStorage.getItem('cookie_consent')
    this.consentGiven = consent !== null
  },
  methods: {
    acceptConsent() {
      localStorage.setItem('cookie_consent', 'accepted')
      this.consentGiven = true
    },
  },
}
</script>
